import { AccountDetail } from './AccountDetail';

// The account page the grids open: the Account 360 page, on the account in ?accountId=, or a new
// one without it.
export function AccountMainSample() {
  return <AccountDetail queryParameterName="accountId" />;
}
